import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import CollectionAddAndEdit from '@components/CollectionAddAndEdit';
import { toastError } from '@components/Toast';

import ApiClient from '@lib/apiClient';

import { checkAnyUserType } from '@utils/Util';

const AddNewSection = () => {
	const [isAddCollection, setIsAddCollection] = useState(false);
	const navigate = useNavigate();

	const handleAddNewSupplierEvent = async () => {
		await ApiClient.POST('supplierAddEvent', {})
			.then(() => {
				navigate('/suppliers/add');
			})
			.catch(() => {
				toastError('Event was unsuccessful!');
			});
	};
	return (
		<div className="button-add-new">
			<div className="btn-group">
				<button
					type="button"
					className="button pr-1 dropdown-toggle dropdown-toggle-split size32"
					data-toggle="dropdown"
					aria-haspopup="true"
					aria-expanded="false"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="22"
						height="22"
						viewBox="0 0 23 22"
						fill="none"
					>
						<path
							d="M11.5 20.1668C16.5627 20.1668 20.6667 16.0628 20.6667 11.0002C20.6667 5.93755 16.5627 1.8335 11.5 1.8335C6.43743 1.8335 2.33337 5.93755 2.33337 11.0002C2.33337 16.0628 6.43743 20.1668 11.5 20.1668Z"
							stroke="#21242B"
							strokeWidth="1.5"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							d="M15.3891 10.9999H7.61091"
							stroke="#21242B"
							strokeWidth="1.5"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							d="M11.5 7.11084V14.889"
							stroke="#21242B"
							strokeWidth="1.5"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</button>
				<div className="dropdown-menu dropdown-menu-right shadow">
					<a className="dropdown-item" href="/brands/add">
						Brand
					</a>

					<a className="dropdown-item" href="/clients/add">
						Client
					</a>

					<a className="dropdown-item" href="#" onClick={() => setIsAddCollection(true)}>
						Collection
					</a>

					{checkAnyUserType([
						'ADMIN',
						'SUPPLY_CHAIN',
						'MATERIAL_MANAGEMENT',
						'INVENTORY_MANAGEMENT'
					]) && (
						<a className="dropdown-item" href="#" onClick={() => handleAddNewSupplierEvent()}>
							Suppliers
						</a>
					)}
				</div>
			</div>
			{isAddCollection && (
				<CollectionAddAndEdit
					type="ADD_NEW"
					title="Create new collection"
					onSubmiCollection={() => setIsAddCollection(false)}
					onClose={() => setIsAddCollection(false)}
				/>
			)}
		</div>
	);
};

export default AddNewSection;
